var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterSnsYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E83F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4707 14.9208L15.1152 9.27142C14.9186 9.12017 14.6848 9.02807 14.4398 9.00546C14.1949 8.98286 13.9487 9.03067 13.7289 9.14349C13.5091 9.25631 13.3244 9.42968 13.1956 9.64409C13.0669 9.8585 12.9991 10.1054 13 10.3571V21.6494C13.0003 21.9005 13.0689 22.1466 13.1982 22.3601C13.3274 22.5735 13.5122 22.7459 13.7318 22.858C13.9514 22.97 14.1971 23.0172 14.4414 22.9944C14.6858 22.9715 14.9191 22.8795 15.1152 22.7286L22.4707 17.0857C22.635 16.9597 22.7684 16.7964 22.8603 16.6085C22.9522 16.4206 23 16.2134 23 16.0033C23 15.7931 22.9522 15.5859 22.8603 15.398C22.7684 15.2101 22.635 15.0468 22.4707 14.9208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSnsYoutube);
export default __webpack_public_path__ + "static/media/footer_sns_youtube.de4ffd8c261371e71eec9fa68d7b1575.svg";
export { ForwardRef as ReactComponent };